import { useSearchParams } from 'react-router';
import { useNavigate } from 'react-router';

import { djs } from '@/lib/formatters';
import { DataTable } from '@/components/ui/data-table';
import { DataTableGrouped } from '@/components/data-table-grouped';
import { DATE_SHORT_FORMAT } from '@/lib/formatters';
import { columns } from './columns';
import { Promotion } from '@/models/promotion';

interface Props {
  promotions: Promotion[];
  success: boolean;
}

export default function PromotionListTable({ promotions, success }: Props) {
  const columnLabels = columns.map((col) => col.meta?.label ?? '');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const viewBy = searchParams.get('view_by') ?? '';
  const groupedPromotions = viewBy
    ? promotions.reduce(
        (acc, cur) => {
          let key = '-';

          if (viewBy === 'start') {
            key = djs(cur.duration.starts_at).format(DATE_SHORT_FORMAT);
          } else if (viewBy === 'end') {
            const endDate = cur.duration.ends_at;

            key = endDate
              ? djs(endDate).format(DATE_SHORT_FORMAT)
              : 'No End Date';
          }

          if (!acc[key]) {
            acc[key] = [];
          }

          acc[key].push(cur);
          return acc;
        },
        {} as Record<string, Promotion[]>,
      )
    : {};

  function onRowClick(promotion: Promotion) {
    navigate(`/promotions/${promotion.id}`);
  }

  return viewBy ? (
    <DataTableGrouped
      columns={columns}
      columnLabels={columnLabels}
      data={groupedPromotions}
      onRowClick={onRowClick}
      success={success}
    />
  ) : (
    <DataTable
      columns={columns}
      data={promotions}
      onRowClick={onRowClick}
      success={success}
    />
  );
}
